var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFitnessCenter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5781 12.8594L19.9844 14.3125L17.875 16.4219L19.2812 17.875L17.875 19.2812L16.4219 17.875L14.3125 19.9844L12.8594 18.5781L11.4531 19.9844L10 18.5781L13.5625 15.0156L4.98438 6.4375L1.42188 10L0.015625 8.54688L1.42188 7.14062L0.015625 5.6875L2.125 3.57812L0.71875 2.125L2.125 0.71875L3.57812 2.125L5.6875 0.015625L7.14062 1.42188L8.54688 0.015625L10 1.42188L6.4375 4.98438L15.0156 13.5625L18.5781 10L19.9844 11.4531L18.5781 12.8594Z",
    fill: "#000E4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFitnessCenter);
export default __webpack_public_path__ + "static/media/fitness_center.af04d9dffc62a4d08a6c8c8e3638adce.svg";
export { ForwardRef as ReactComponent };